import { useSyncExternalStore } from 'react';
import { cn } from '@/lib/cn';

type Toast = { id: number; message: string; tone: 'success' | 'error' | 'info' };
let toasts: Toast[] = [];
let nextId = 1;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export function toast(message: string, tone: Toast['tone'] = 'success', ms = 3500): void {
  const t = { id: nextId++, message, tone };
  toasts = [...toasts, t];
  emit();
  setTimeout(() => {
    toasts = toasts.filter((x) => x.id !== t.id);
    emit();
  }, ms);
}

export function Toaster() {
  const list = useSyncExternalStore(
    (fn) => {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
    () => toasts,
  );
  return (
    <div aria-live="polite" className="pointer-events-none fixed inset-x-0 bottom-24 z-50 flex flex-col items-center gap-2 px-4 lg:bottom-6">
      {list.map((t) => (
        <div
          key={t.id}
          role="status"
          className={cn(
            'pointer-events-auto max-w-md rounded-xl px-4 py-3 text-base font-medium shadow-lg',
            t.tone === 'success' && 'bg-stone-900 text-white',
            t.tone === 'error' && 'bg-red-700 text-white',
            t.tone === 'info' && 'bg-sky-800 text-white',
          )}
        >
          {t.message}
        </div>
      ))}
    </div>
  );
}
